<script lang="ts">
import { defineComponent, ref } from 'vue'

import Home from './components/Home.vue'

export default defineComponent({
  name: 'App',
  components: {
    Home,
  },
  setup() {
    const user = 'uninen'
    const isDj = true
    const djDashboardUrl = '/dj/'
    const isAdmin = false
    const isAnonymous = false
    const debug = process.env.NODE_ENV === 'development'
    const open = ref(false)
    const version = '0.1a'

    return {
      user,
      isDj,
      isAdmin,
      isAnonymous,
      debug,
      open,
      version,
      djDashboardUrl,
    }
  },
})
</script>

<template>
  <Suspense>
    <template #default>
      <div class="w-full flex flex-col min-h-screen bg-gray-100">
        <nav class="bg-black">
          <div class="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex items-center justify-between h-16">
              <div class="flex items-center">
                <div class="flex-shrink-0">
                  <img class="h-8 w-8" src="@/assets/img/apple-touch-icon.png" alt="Slipmat logo" />
                </div>
                <div
                  class="no-underline font-bold flex my-2 pl-2 lg:pl-3 items-center relative min-h-0 text-2xl text-white"
                >
                  Slipmat.io
                </div>
                <div class="hidden md:block">
                  <div class="ml-10 flex items-baseline">
                    <a
                      v-if="false"
                      href="#"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Discover</a
                    >
                    <a
                      v-if="false"
                      href="#"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Artists</a
                    >
                    <a
                      href="https://backstage.slipmat.io"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Backstage</a
                    >

                    <a
                      href="https://discord.gg/PCSwhkZ"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Chat</a
                    >

                    <a
                      href="https://blog.slipmat.io/"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Blog</a
                    >

                    <a
                      href="#changelog"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Changelog</a
                    >

                    <a
                      v-if="false"
                      :href="djDashboardUrl"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >DJ Dashboard</a
                    >

                    <a
                      v-if="false"
                      href="admin/"
                      class="ml-4 px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                      >Admin</a
                    >
                  </div>
                </div>
              </div>

              <div class="hidden md:block">
                <div class="ml-4 flex items-center md:ml-6">
                  <a
                    class="p-1 border-2 border-transparent text-red-500 rounded-full hover:text-white focus:outline-none focus:text-white focus:bg-gray-700"
                    aria-label="Notifications"
                    href="/backstage/"
                    v-if="user.backstageNotifications || user.backstageMessages"
                    title="You have notifications on Backstage"
                  >
                    <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                  </a>

                  <div class="ml-3 relative flex-1 flex">
                    <div class="flex justify-between flex-row flex-shrink-0 items-center">
                      <div class="text-base block mr-3 text-slipmat-400">Admin View</div>

                      <a
                        class="max-w-xs block text-sm rounded-full text-white focus:outline-none focus:shadow-solid"
                        id="user-menu"
                        aria-label="User menu"
                        aria-haspopup="true"
                        x-bind:aria-expanded="open"
                        href=""
                      >
                        <img
                          class="h-8 w-8 rounded-full"
                          src="https://media.slipmat.io/media/profile_photos/ccc7b1cd-c0dd-4fd8-86aa-f375de65ff98_1555553750.jpg"
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="-mr-2 flex md:hidden">
                <button
                  class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
                  x-bind:aria-label="open ? 'Close main menu' : 'Main menu'"
                  x-bind:aria-expanded="open"
                  @click="open = !open"
                >
                  <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path
                      :class="{ 'inline-flex': !open }"
                      class="inline-flex"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                    <path
                      :class="{ hidden: !open, 'inline-flex': open }"
                      class="hidden"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="md:hidden" :class="{ hidden: !open }">
            <div class="px-2 pt-2 pb-3 sm:px-3">
              <span
                class="block px-3 py-2 rounded-md text-base font-medium text-slipmat-500 bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700"
                >Homepage</span
              >

              <a
                href="https://backstage.slipmat.io/"
                class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                >Backstage</a
              >

              <a
                href="https://discord.gg/PCSwhkZ"
                class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                >Chat</a
              >

              <a
                href="https://blog.slipmat.io/"
                class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                >Blog</a
              >

              <a
                v-if="false"
                href="/dj/"
                class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                >DJ Dashboard</a
              >

              <a
                v-if="false"
                href="admin/"
                class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-slipmat-500 hover:bg-gray-950 focus:outline-none focus:text-white focus:bg-gray-700"
                >Admin</a
              >
            </div>
            <div class="pt-4 pb-3 border-t border-gray-700">
              <div v-if="!isAnonymous && user" class="flex items-center px-5">
                <div class="flex-shrink-0">
                  <a href="https://slipmat.io/account/">
                    <img
                      class="h-10 w-10 rounded-full"
                      src="https://media.slipmat.io/media/profile_photos/ccc7b1cd-c0dd-4fd8-86aa-f375de65ff98_1555553750.jpg"
                      alt=""
                    />
                  </a>
                </div>
                <div class="ml-3">
                  <div class="text-base font-medium leading-none text-white">
                    <a href="https://slipmat.io/account/">{{ user.username }}</a>
                  </div>
                  <div class="mt-1 text-sm font-medium leading-none text-gray-400">
                    <a href="https://slipmat.io/account/">{{ user.email }}</a>
                  </div>
                </div>
              </div>
              <div v-else class="flex items-center px-5">
                <a class="btn" href="https://slipmat.io/account/login/">Log In</a>
              </div>

              <div
                class="mt-3 px-2"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
              >
                <a
                  v-if="false"
                  href="#"
                  class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                  role="menuitem"
                  >Your Profile</a
                >
                <a
                  v-if="false"
                  href="#"
                  class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                  role="menuitem"
                  >Settings</a
                >
                <a
                  v-if="false"
                  href="#"
                  class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                  role="menuitem"
                  >Sign out</a
                >
              </div>
            </div>
          </div>
        </nav>
        <main class="w-full max-w-9xl mx-auto sm:py-6 sm:px-6 lg:px-8">
          <!-- Content -->
          <div v-if="!debug" class="bg-green-300 border-4 border-green-600 p-6 text-lg mb-6">
            You are looking at a static and unfinished development version of Slipmat EventPlanner.
            The data is not real, it's static development data. No changes are persisted, everything
            resets when you refresh the page. This is here only for debugging and testing purposes.
          </div>

          <home></home>
        </main>
        <footer class="text-center mt-20 pt-8 pb-8 text-lg text-shadow text-white bg-black">
          <strong>Slipmat.io</strong>
          {{ version }}
          <br />
          <div class="text-base text-gray-100">
            Community for DJs and music lovers.
            <br />
            <!-- <span class="text-sm text-gray-400">Built on {{ buildTime }}</span> -->
          </div>
        </footer>
      </div>
    </template>
    <template #fallback>
      <div class="h-screen w-full flex items-center bg-gray-100">
        <div class="flex flex-1 justify-center text-center w-full">
          <span class="text-4xl font-semibold">Loading...</span>
        </div>
      </div>
    </template>
  </Suspense>
</template>
